export class Message {
  name: string;
  text: string;
  type: string;
}
